import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class LocalStorageService implements OnDestroy {
  private onStorageChanges = new Subject<{ key: string; value: any }>();
  public changes = this.onStorageChanges.asObservable().pipe(share());

  constructor() {
    this.start();
  }

  ngOnDestroy() {
    this.stop();
  }

  public store(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
    this.onStorageChanges.next({ key: key, value: data });
  }

  public get(key: string) {
    const data = localStorage.getItem(key);
    return JSON.parse(data);
  }

  public clear(key) {
    localStorage.removeItem(key);
    this.onStorageChanges.next({ key: key, value: null });
  }

  private start(): void {
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      let v;
      try {
        v = JSON.parse(event.newValue);
      } catch (e) {
        v = event.newValue;
      }
      this.onStorageChanges.next({ key: event.key, value: v });
    }
  }

  private stop(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
    this.onStorageChanges.complete();
  }
}
